<template>
  <div class="arrow-icon" :style="iconDirection">
    <svg
      :width="iconSize"
      viewBox="0 0 36 54"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-miterlimit:1.5;"
    >
      <path
        d="M9.014,9.014l17.524,17.524l-17.524,17.525"
        :style="`fill:none;stroke:${color};stroke-width:10px;`"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "ArrowIcon",
  props: {
    direction: {
      type: String,
      default: "left"
    },
    color: {
      type: String,
      default: "#000"
    },
    size: {
      type: [String, Number]
    }
  },
  data: () => ({
    sm: 6,
    md: 10,
    lg: 16
  }),
  computed: {
    iconSize() {
      if (typeof this.size === "string") {
        switch (this.size) {
          case "small":
            return `${this.sm}px`;
          case "medium":
            return `${this.md}px`;
          case "large":
            return `${this.lg}px`;
          default:
            return this.size;
        }
      }
      if (typeof this.size === "number") {
        return `${this.size}px`;
      }
      return "10px";
    },
    iconDirection() {
      const up = "rotate(270deg)";
      const right = "rotate(0deg)";
      const left = "rotate(180deg)";
      const bottom = "rotate(90deg)";
      switch (this.direction) {
        case "up":
          return { transform: up };
        case "right":
          return { transform: right };
        case "left":
          return { transform: left };
        case "bottom":
          return { transform: bottom };
        default:
          return { transform: right };
      }
    }
  }
};
</script>
<style>
.arrow-icon {
  display: inherit;
}
</style>
